<template>
  <el-col>
    <el-card class="data">
      <div class="data-title" slot="header">
        <img class="report-img" src="@/assets/images/tracks.svg" alt="" />
        <span>TOP TRACKS</span>
        <router-link class="overview-action" :to="{ name: 'Label Track Overview' }"
          >OVERVIEW<i class="el-icon-arrow-right"></i
        ></router-link>
      </div>
      <div
        class="tableCommands"
        :class="window.width < '710' ? 'flex-end' : 'd-none'"
      >
        <p
          class='ml5'
          v-for="(item, index) in columns"
          :key="index"
          @click="handleCommand(item)"
          :class="{ active: columnShown === item.name}"
        >
          {{ item.name }}
        </p>
      </div>
      <el-table
        :data="track"
        class="w100 dashboard-table"
        v-loading="loading_track"
      >
        <el-table-column label="Title" prop="title" align="left">
          <template slot-scope="props">
            <a :href="handleSelect(props.row)">
              {{ props.row.title }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          label="Previews"
          prop="previews"
          v-if="columnShown === 'Previews' || window.width > '710'"
          align="center"
          width="150%"
          sortable
        ></el-table-column>
        <el-table-column
          label="Videos"
          prop="video"
          v-if="columnShown === 'Videos' || window.width > '710'"
          align="center"
          sortable
        ></el-table-column>
        <el-table-column
          label="Views"
          prop="views"
          v-if="columnShown === 'Views' || window.width > '710'"
          align="center"
          :formatter="commaNumTable"
          sortable
        ></el-table-column>
        <el-table-column
            label="Subscribers"
            prop="subscribers"
            v-if="columnShown === 'subscribers' || window.width > '710'"
            align="center"
            :formatter="commaNumTable"
            width="200%"
            sortable
        ></el-table-column>
        <el-table-column
          label="Actual CPM"
          prop="actual_cpm"
          v-if="columnShown === 'Actual CPM' || window.width > '710'"
          align="center"
          width="220%"
          :formatter="commaNumTable"
          sortable
        >
          <template slot-scope="props">
            {{ props.row.isFree ? 'Free' : '$'+props.row.actualCPM }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </el-col>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  components: {},

  data() {
    return {
      columnShown: 'Previews',
      columns: [
        {
          name: 'Previews',
          command: 'previews'
        },
        {
          name: 'Videos',
          command: 'videos'
        },
        {
          name: 'Views',
          command: 'views'
        },
        {
          name: 'Actual CPM',
          command: 'actual_cpm'
        }
      ],
      dev: process.env.VUE_APP_IN_DEVELOPMENT
    }
  },

  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['mcn_role']),

    ...mapState('labelDashboard', ['loading_track', 'track'])
  },

  methods: {
    ...mapActions('labelDashboard', ['readTrack']),

    handleCommand(column) {
      this.columnShown = column.name
      this.readTrack({column: 'views', type: 'desc'})
    },

    handleSelect(data) {
      return '/artist/my-tracks/track-details?track=' + data.track
    }
  },

  created() {
    this.readTrack({column: 'views', type: 'desc'})
    window.addEventListener('resize', this.windowWidth)
    this.windowWidth()
  },

  destroyed() {
    window.removeEventListener('resize', this.windowWidth)
  }
}
</script>
